export const setStaticPages = (filter: any) => ({
    type: 'SET_PAGES',
    payload: filter,
  });